module.exports = __webpack_public_path__ + "static/img/R417A.7507483.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productList/oem/R417A.jpg
// module id = oeOC
// module chunks = 1